var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.684419 1.56699L0.684392 1.56696C0.291992 1.17456 0.57154 0.5 1.12631 0.5H22.8739C23.4288 0.5 23.7081 1.17462 23.3158 1.56697L23.6694 1.92052L23.3158 1.56698L14.6464 10.2374L14.5 10.3839V10.591V22.8741C14.5 23.3795 13.9289 23.6747 13.5166 23.3861L13.5165 23.386L9.76662 20.7621C9.76658 20.762 9.76655 20.762 9.76651 20.762C9.59945 20.645 9.49999 20.4539 9.49999 20.25V10.591V10.3839L9.35357 10.2375L0.684419 1.56699Z",
    stroke: "#03422F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c61cec595c4d4a3f13eac989a6b5280d.svg";
export { ForwardRef as ReactComponent };